<div class= "mar-top-5 mar-bot-3 flex" >
  <button class="drop-btn w100 relative search-inp no-padding"  *ngIf="GlobalConstants.data.personalized_config.desktop_search">
    <div class="pointer h100" dropdown>
      <div dropdownToggle class="drop-txt h100">

          <svg class= "se-ic" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
            <g>
              <path fill="#FCFCFF" d="M495,466.2L377.2,348.4c29.2-35.6,46.8-81.2,46.8-130.9C424,103.5,331.5,11,217.5,11C103.4,11,11,103.5,11,217.5   S103.4,424,217.5,424c49.7,0,95.2-17.5,130.8-46.7L466.1,495c8,8,20.9,8,28.9,0C503,487.1,503,474.1,495,466.2z M217.5,382.9   C126.2,382.9,52,308.7,52,217.5S126.2,52,217.5,52C308.7,52,383,126.3,383,217.5S308.7,382.9,217.5,382.9z"/>
            </g>
          </svg>
          <input class="search-placeholder rad-10 pad-top-3 fnt-15" placeholder="Search for offer" [(ngModel)]="selectedCat" (input)="debouncedPopulateMerchantList($event)">

      </div>
      <div class="dropdown-menu default-dropdown-menu w100" *dropdownMenu>
        <div class="dropdown location-dropdown static" *ngIf = "(searchInput.length > 2) ">
            <div>
              <div class="block loc-results" *ngIf = "!searching && (merchantList.length > 0)">
                <div>
                  <div class="option-box" *ngFor="let merchant of merchantList">
                    <a [routerLink]="'/offers/offer-details/'+merchant.id+'/all/'+merchant.attributes.name?.split(' ').join('-').split(',').join('').split('(').join('').split(')').join('').toLowerCase()" class="option-name c555 f500" (click)="gtmSearchBar(merchant.attributes.name)">{{merchant.attributes.name}}</a>
                  </div>
                </div>

              </div>
              <div class="block loc-results" *ngIf = "searching">
                <div class="text-center" ><img class="loader searching"  src = "../../../../assets/images/spin.gif"></div>
              </div>
              <div *ngIf = "merchantList.length == 0 && searchInput.length > 2 && !searching" class="pad-10 f600 fnt-14">No Results found for "{{searchInput}}"</div>
            </div>
        </div>
      </div>
    </div>
  </button>
</div>
